import React from 'react';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import { Link } from 'react-router-dom'; // For navigation
import '../../styles/Footer.css';
import eraLogo from '../../assets/era_logo.png';

function Footer() {
  return (
    <footer className='footer'>
      <div className='footerContent'>
        <div className='socialLinks'>
          <a
            href='https://www.facebook.com/share/16DpGsM9w5/'
            target='_blank'
            rel='noopener noreferrer'
            aria-label='Facebook'
          >
            <FacebookIcon className='socialIcon' />
          </a>
          <a
            href='https://www.instagram.com/jsproperty.sg?igsh=aGJjam90ZXIxbnlk'
            target='_blank'
            rel='noopener noreferrer'
            aria-label='Instagram'
          >
            <InstagramIcon className='socialIcon' />
          </a>          
          
        </div>
        <div className='linkBox'>
          <Link to='/disclaimer' className='footerText footerLink'>
            Disclaimer
          </Link>
          <Link to='/terms_of_use' className='footerText footerLink'>
            Terms Of Use
          </Link>
          <Link to='/privacy_policy' className='footerText footerLink'>
            Privacy Policy
          </Link>
        </div>
        <div className='eraSection'>
          <img src={eraLogo} alt='ERA Realty Network' className='eraLogo' />
          <p className='eraText'>ERA Realty Network Pte Ltd</p>
        </div>
        <div className='footerText copyrightText'>
          © {new Date().getFullYear()} JS Property. All rights reserved.
        </div>
        
      </div>
    </footer>
  );
}

export default Footer;